<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title--Front-Matter-">The Cursing Stones Murder</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">An Inspector Littlejohn Mystery</p>
<p class="ORIM-Author-Name--Front-Matter-">George Bellairs</p>
<p class="ORIM-Author-Name--Front-Matter-"><img alt="Logo" src="images/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol-001.vue?d72289de